import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useBillingQueryContext } from '../../contexts';
import { CURRENT_CUSTOM_EVENTS_STORED, CUSTOM_EVENTS_STORED } from '../../constants';
import { createColumns, createRows, queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { PageActions } from './PageActions';
import { createRowCell } from './TableCell';

export const TEXT = {
  PAGE_TITLE: 'Custom events usage',
};

export const CustomEventsUsage = () => {
  const {
    projectIds,
    pickManyProjectMetrics,
    pickManyOrgMetrics,
    projectMetricsByProjectId,
    isLoading,
  } = useBillingQueryContext();
  const { search } = useLocation();

  useEffect(() => {
    window.scrollTo();
  }, []);

  const metricNames = [CURRENT_CUSTOM_EVENTS_STORED, CUSTOM_EVENTS_STORED];

  const orgMetrics = pickManyOrgMetrics(metricNames);
  const metricsByProjectId = projectIds.reduce(
    (acc, projectId) => ({
      [projectId]: pickManyProjectMetrics(projectId, metricNames),
      ...acc,
    }),
    {},
  );

  const rows = createRows(orgMetrics, projectMetricsByProjectId);
  const columns = createColumns(metricsByProjectId);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={{
        content: 'Usage and Billing',
        href: `/payments/info${search}`,
      }}
      pageTitle={TEXT.PAGE_TITLE}
      pageActions={<PageActions />}
      isLoading={isLoading}
      queryByFn={queryByFn}
    />
  );
};
